// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__-rjuX","modal__footer":"styles_modal__footer__xCMfX"};